/**
 * NgKit theme preset definition based on PrimeNG Nora theme.
 * Provides consistent styling foundation for AngularKit components.
 *
 * Theme Structure:
 * - Primitive colors and palettes are defined in tokens/primitive-colors.ts
 * - Semantic configurations are in tokens/semantic-config.ts
 * - Color schemes are in tokens/color-scheme.ts
 * - Component-specific styles are organized in tokens/components/
 * @see tokens/index.ts for all exported configurations
 */

import { definePreset } from '@primeuix/themes';
import Nora from '@primeuix/themes/nora';
import { primitiveColors } from './tokens/primitive-colors';
import { semanticConfig } from './tokens/semantic-config';
import { lightColorScheme } from './tokens/color-scheme';
import { allComponentsConfig } from './tokens/components/index';

export const NgKitTheme = definePreset(Nora, {
  primitive: primitiveColors,
  semantic: {
    ...semanticConfig,
    colorScheme: lightColorScheme,
  },
  components: allComponentsConfig,
});
